import Serializable from "Serializable";
import RiSubCategoryType from "../../../../../../Constants/RiSubCategoryType.js";
import AnnotationSettings from "../AnnotationSettings.js";
import RiPanelOneilListSettings from "./RiPanelOneilListSettings.js";
import RiPanelNewSettings from "./RiPanelNewSettings.js";
import RiPanelAiSettings from "./RiPanelAiSettings.js";
import RiPanelTransactionsSettings from "./RiPanelTransactionsSettings.js";

class RiPanelStockViewSettings extends Serializable {

    getDefaulSettings() {
        this.ActiveSelectedSubCategory = RiSubCategoryType.News;
        this.ActiveColSetId = 0;
        this.AnnotationSettings = this.getDefaultAnnotationSettings();
        this.OneilListSettings = this.getDefaultOneilListSettings();
        this.NewSettings = this.getDefaultNewsSettings();
        this.AiSettings = this.getDefaultAiSettings();
        this.TransactionsSettings = this.getDefaultTransactionsSettings();
        return this;
    }

    onSeralisedInfoRecieved(serializedValue) {
        this.ActiveSelectedSubCategory = serializedValue.ActiveSelectedSubCategory ? serializedValue.ActiveSelectedSubCategory : RiSubCategoryType.News;
        this.ActiveColSetId = serializedValue.ActiveColSetId ? serializedValue.ActiveColSetId : 0;
        this.AnnotationSettings = serializedValue.AnnotationSettings ? serializedValue.AnnotationSettings : this.getDefaultAnnotationSettings();
        this.OneilListSettings = serializedValue.OneilListSettings ? serializedValue.OneilListSettings : this.getDefaultOneilListSettings();
        this.NewSettings = serializedValue.NewSettings ? serializedValue.NewSettings : this.getDefaultNewsSettings();
        this.AiSettings = serializedValue.AiSettings ? serializedValue.AiSettings : this.getDefaultAiSettings();
        this.TransactionsSettings = serializedValue.TransactionsSettings ? serializedValue.TransactionsSettings : this.getDefaultTransactionsSettings();
    }

    getObjectMapKey() {
        return "RiPanelStockViewSettings";
    }

    getDataObject() {
        return {
            ActiveSelectedSubCategory: this.ActiveSelectedSubCategory,
            ActiveColSetId: this.ActiveColSetId,
            AnnotationSettings: this.AnnotationSettings,
            OneilListSettings: this.OneilListSettings,
            NewSettings: this.NewSettings,
            AiSettings: this.AiSettings,
            TransactionsSettings: this.TransactionsSettings
        };
    }

    getDefaultAnnotationSettings() {
        const annotationSettings = new AnnotationSettings();
        return annotationSettings;
    }

    getDefaultOneilListSettings() {
        const oneilListSettings = new RiPanelOneilListSettings();
        return oneilListSettings;
    }

    getDefaultNewsSettings() {
        const newsSettings = new RiPanelNewSettings();
        return newsSettings;
    }
    
    getDefaultAiSettings() {
        const aiSettings = new RiPanelAiSettings();
        return aiSettings;
    }

    getDefaultTransactionsSettings() {
        const transactionsSettings = new RiPanelTransactionsSettings();
        return transactionsSettings;
    }
}

export default RiPanelStockViewSettings;
